/* eslint-disable @cspell/spellchecker */

export const VIDEO_CALL_POLICIES_URL =
  'https://support.nutrisense.io/en_us/video-call-cancellation-reschedule-and-no-show-policy' +
  '-BJIHJ9Ayle?utm_medium=ns-mobile-app'

export const PAYMENT_MISSING_TITLE = 'Add a payment method to secure your spot'

export const ALLOWANCE_COVERED_TITLE = "You won't be charged"
export const ALLOWANCE_COVERED_BODY =
  "We ask for a credit card to reserve your appointment,\
  but we'll use your existing credit balance to cover this call."

export const INSURANCE_IN_REVIEW_DISCLAIMER = '* If insurance policy is ineligible.'
export const INSURANCE_IN_REVIEW_PAYMENT_TITLE = 'No Surprise Charges'
export const INSURANCE_IN_REVIEW_PAYMENT_BODY =
  "Your payment method secures your spot.\
  You'll only be charged when your appointment begins if your insurance is ineligible\
  — we will be in touch if this happens."

export const INSURANCE_COVERED_PAYMENT_TITLE = 'No Surprise Charges'
export const INSURANCE_COVERED_PAYMENT_BODY =
  "We ask for a credit card to reserve your appointment,\
  but we'll never charge you for the call without permission.\
  This simply covers late cancellations or no-shows."

export const SELF_PAY_PAYMENT_TITLE = "You won't be charged yet"
export const SELF_PAY_PAYMENT_BODY =
  "Your payment method secures your spot. You'll only be charged when your appointment begins."

export const SELF_PAY_MISSING_PAYMENT_BODY =
  "A credit card is required to keep your appointment. You'll only be charged when your appointment begins."

export const DEFAULT_PAYMENT_TITLE = 'No Surprise Charges'
export const DEFAULT_PAYMENT_BODY =
  "Your payment method secures your spot, but we'll never charge you for the call without permission."
